import React from "react";
import { useTheme } from "@material-ui/core";
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { isNil } from "lodash";

// const valor = {
//   valName: "Score",
//   showTooltip: true,
//   def: [
//     {
//       label: "Math",
//       val: 120,
//     },
//     {
//       label: "Chinese",
//       val: 98,
//     },
//     {
//       label: "English",
//       val: 86,
//     },
//     {
//       label: "Biology",
//       val: 12,
//     },
//     {
//       label: "Geo",
//       val: 38,
//     },
//     {
//       label: "Quimica",
//       val: 60,
//     },
//   ],
// };

export default function SimpleRadarChart({ data }) {
  const { valor } = data;
  const theme = useTheme();

  if (isNil(valor?.def)) {
    return null;
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <RadarChart
        data={valor.def.map((i) => {
          return {
            ...i,
            name: "val",
          };
        })}
      >
        <PolarGrid />
        <PolarAngleAxis
          dataKey="label"
          stroke={theme.palette.content.titleTextColor}
        />

        <Radar
          name={valor?.valName}
          dataKey="val"
          stroke={theme.palette.content.mainColor}
          fill={theme.palette.content.mainColor}
          fillOpacity={0.5}
        />
        {valor?.showTooltip && (
          <Tooltip
            contentStyle={{
              color: theme.palette.text.primary,
              backgroundColor: theme.palette.background.paper,
            }}
          />
        )}
      </RadarChart>
    </ResponsiveContainer>
  );
}
